import IFlowinglySearchResult from '@Shared.Angular/@types/core/contracts/queryModel/search/flowinglySearchResult';
import React from 'react';

interface Props {
  items: IFlowinglySearchResult[];
  onItemClick: (item: IFlowinglySearchResult) => void;
  iconClass: string;
  backgroundColor: string;
}

const Panel: React.FC<Props> = ({
  items,
  onItemClick,
  iconClass,
  backgroundColor
}) => (
  <div className="smart-select-panel" style={{ backgroundColor }}>
    <ul>
      {items.map((item) => (
        <li key={item.id} onClick={() => onItemClick(item)}>
          <i className={iconClass} aria-hidden />
          <span>{item.displayName}</span>
        </li>
      ))}
    </ul>
  </div>
);

export default Panel;
